import { SadmClient } from '@pixacare/dtos';
import { ModuleId } from '@pixacare/forms';
import { StoreQuickModule } from './models/store-quick-module';
import { StoreSadmEntity } from './models/store-sadm-entity';

export type SadmState = {
  clients: {
    [sadmClientId: number]: SadmClient;
  };
  entities: {
    [sadmEntityId: number]: StoreSadmEntity;
  };
  userSadmClients: number[];
  quickModules: {
    [formModuleId in ModuleId]?: StoreQuickModule;
  };
  loadState: {
    [clientCode: string]: { [patientId: number]: boolean };
  };
};

export const initialSadmState: SadmState = {
  clients: {},
  entities: {},
  userSadmClients: [],
  quickModules: {},
  loadState: {},
};
